export type DssBodyClass = 'dss-style-dark' | 'dss-style-light' | 'not-dss-style';

// Espelha DesignSystemSigmaService.isDssLayout(): com useHash:true o path corrente
// vive em window.location.hash, não em window.location.pathname.
export function isDssLayout(hash: string = window.location.hash): boolean {
  return hash.includes('/dss/');
}

/** Lê sessionStorage['theme'] (dark/light) de forma defensiva; null se ausente/inacessível. */
export function readDssTheme(): string | null {
  try {
    const value = sessionStorage.getItem('theme');
    return value && value.length ? value : null;
  } catch {
    return null;
  }
}

/** dss-style-light apenas em DSS+light; dss-style-dark em DSS com dark/ausente; not-dss-style fora do DSS. */
export function resolveDssBodyClass(isDss: boolean, theme: string | null): DssBodyClass {
  if (!isDss) {
    return 'not-dss-style';
  }
  return theme === 'light' ? 'dss-style-light' : 'dss-style-dark';
}

const ALL_DSS_CLASSES: DssBodyClass[] = ['dss-style-dark', 'dss-style-light', 'not-dss-style'];

/** Aplica a classe resolvida ao body e remove as outras duas, espelhando resetDssClass() + add. */
export function applyDssBodyClass(isDss: boolean, theme: string | null): void {
  const resolved = resolveDssBodyClass(isDss, theme);
  ALL_DSS_CLASSES.forEach((className) => document.body.classList.remove(className));
  document.body.classList.add(resolved);
}
